import { Banner, Skeleton } from '../ds/index'
import { HandpickedTree } from './BrandMark'

export function LoadingBlock({ rows = 6 }: { rows?: number }) {
  // Handpicked's own loader: the tree breathing while a leaf falls. Fades in
  // only after a beat, so a quick load never flashes it.
  if (typeof document !== 'undefined' && document.documentElement.dataset.brand === 'handpicked') {
    return (
      <div className="tree-loader" aria-busy="true" aria-label="Loading">
        <span className="tree-loader-mark"><HandpickedTree size={56} /></span>
        <span className="tree-loader-leaf" aria-hidden="true" />
      </div>
    )
  }
  return (
    <div className="stack" aria-busy="true">
      {Array.from({ length: rows }, (_, i) => <Skeleton key={i} height={16} width={`${70 + ((i * 13) % 30)}%`} />)}
    </div>
  )
}

export function ErrorBlock({ error }: { error: string }) {
  return <Banner tone="neg" title="Could not load this screen">{error}</Banner>
}
